import { ipaToFeatures } from "./ipa";
import { PhonemeItem } from "./segmentPhonemes";

/**
 * options for replacing plain vowel pairs with annotated diphthongs, e.g., oʊ > oʊ̯
 * or long vowel, e.g., uu > uː
 */
export function getPhthongAlternates(phonemes: PhonemeItem[]): string[][] {
  const replacements: string[][] = [];
  const possibles = getPossiblePhthongs(phonemes);
  for (const possible of possibles) {
    const alt = getAlt(possible);
    const replacement = [possible, alt];
    replacements.push(replacement);
  }
  return replacements;
}

/** find adjacent syllabic vowels that might indicate a di- or tri-phthong, e.g., ['oʊ'] not ['oʊ̯'] */
export function getPossiblePhthongs(phonemes: PhonemeItem[]): string[] {
  const found = new Set<string>();
  let lastVowel: string | null = null;
  for (const p of phonemes) {
    const checkFeatures = ipaToFeatures(p.phoneme);
    const features = checkFeatures ?? [];
    if (lastVowel === null && features.some(f => f === 'vowel') && features.every(f => f !== 'non-syllabic')) {
      // !V_ & [+vowel,-non-syllabic] - possible start of vowel cluster
      lastVowel = p.phoneme;
    } else if (lastVowel !== null && features.some(f => f === 'vowel') && features.every(f => f !== 'non-syllabic')) {
      // V_ & [+vowel,-non-syllabic] - possible second half of diphthong
      const possible = lastVowel + p.phoneme;
      if (!found.has(possible)) {
        found.add(possible);
      }
      lastVowel = p.phoneme;
    } else {
      lastVowel = null;
    }
  }

  const thongs: string[] = [];
  found.forEach(v => thongs.push(v));
  return thongs;
}

function getAlt(phonemes: string): string {
  if (phonemes.length % 2 === 0) {
    // if it's a repeat of the same phoneme, suggest lengthening
    const one = phonemes.substring(0, phonemes.length / 2);
    const two = phonemes.substring(phonemes.length / 2);
    if (one === two) {
      return `${one}ː`;  // long
    }
  }

  return `${phonemes}\u032F`; // make last phoneme non-syllabic
}
